import { render, staticRenderFns } from "./backExamine.vue?vue&type=template&id=792d2b56&"
import script from "./backExamine.vue?vue&type=script&lang=js&"
export * from "./backExamine.vue?vue&type=script&lang=js&"
import style0 from "./backExamine.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports